// extracted by mini-css-extract-plugin
export var legendIndicator = "_cz-1";
export var legendRight = "_cz-0";